import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { PacingStatus } from "@features/mmm/components/shared/pacing-status";
import { useClientSettings } from "@pages/mmm/hooks/use-client-settings";

import { type TableRowType } from "../mid-cycle-rebudgeting-table";

export const PacingStatusDataFormatter = ({
  column,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as TableRowType;
  const { percentOfCycleCompleted } = useClientSettings();

  const actual = row.data.actualSpend;
  const budgeted = row.data.budgetedSpend * percentOfCycleCompleted;

  return (
    <div className="font-sans flex-center h-full overflow-hidden">
      <PacingStatus
        className="text-xs font-semibold rounded-full"
        actual={actual}
        budgeted={budgeted}
        concise
      />
    </div>
  );
};
